import React from "react";
import ErrorField from "./error";
import { UnitLabels } from "core/enum";
import { observer } from "mobx-react";
import { SelectField } from "components/support";

const UnitLabelsOptions = Object.values(UnitLabels).map(i => ({
  value: i.unit,
  label: i.name
}));

const UnitLabelField = ({ errors, row, onChange }) => {
  const { unit_label } = row;
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors && !!foundErrors.errors && !!foundErrors.errors.unit_label;

  return (
    <div>
      <SelectField
        fullWidth
        options={UnitLabelsOptions}
        value={unit_label}
        onChange={(_, value) => onChange(value)}
      />
      {hasErrors && <ErrorField error={foundErrors.errors.unit_label} />}
    </div>
  );
};

export default observer(UnitLabelField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/unit-label.js